import { Component, ElementRef, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";

declare interface RouteInfo {
  id: number;
  path: string;
  title: string;
  icon: string;
  class: string;
}

const pageDashboard = {
  id: 10,
  path: "/dashboard",
  title: "Dashboard",
  icon: "fa fa-home",
  class: "",
};

const pageUserManagement = {
  id: 13,
  path: "/user-management",
  title: "User Management",
  icon: "fa fa-user",
  class: "",
};

const pageMyTimesheet = {
  id: 11,
  path: "/my-timesheet",
  title: "My Timesheet",
  icon: "fa fa-calendar-o",
  class: "",
};

const pageTimesheetApproval = {
  id: 12,
  path: "/verify-timesheet",
  title: "Timesheet Approval",
  icon: "fa fa-calendar-check-o",
  class: "",
};

const pageLeaveManagement = {
  id: 14,
  path: "/leave-management",
  title: "Leave Management",
  icon: "fa fa-sticky-note-o",
  class: "",
};

const pageTeamManagement = {
  id: 100,
  path: "/team-management",
  title: "Team Management",
  icon: "fa fa-users",
  class: "",
};

const pageProjectManagement = {
  id: 101,
  path: "/project-management",
  title: "Project Management",
  icon: "fa fa-cube",
  class: "",
};

const pageProjectApproval = {
  id: 102,
  path: "/project-approval",
  title: "Project Approval",
  icon: "fa fa-cube",
  class: "",
};

const pageMasterSetup = {
  id: 103,
  path: "/master-setup",
  title: "Master Setup",
  icon: "fa fa-cube",
  class: "",
}

export const ROUTES: RouteInfo[] = [
  {
    id: 10,
    path: "/dashboard",
    title: "Dashboard",
    icon: "fa fa-home",
    class: "",
  },
  {
    id: 13,
    path: "/user-management",
    title: "User Management",
    icon: "fa fa-user",
    class: "",
  },
  {
    id: 11,
    path: "/my-timesheet",
    title: "My Timesheet",
    icon: "fa fa-calendar-o",
    class: "",
  },
  {
    id: 12,
    path: "/verify-timesheet",
    title: "Timesheet Approval",
    icon: "fa fa-calendar-check-o",
    class: "",
  },
  {
    id: 14,
    path: "/leave-management",
    title: "Leave Management",
    icon: "fa fa-sticky-note-o",
    class: "",
  },

  {
    id: 100,
    path: "/team-management",
    title: "Team Management",
    icon: "fa fa-users",
    class: "",
  },
  {
    id: 101,
    path: "/project-management",
    title: "Project Management",
    icon: "fa fa-cube",
    class: "",
  },
  {
    id: 102,
    path: "/project-approval",
    title: "Project Approval",
    icon: "fa fa-cube",
    class: "",
  },
  {
    id: 103,
    path: "/master-setup",
    title: "Master Setup",
    icon: "fa fa-cube",
    class: "",
  }

  // {
  //   id: 15,
  //   path: "/role-management",
  //   title: "Role Management",
  //   icon: "fa fa-home",
  //   class: "",
  // },
];

export const MENU_ADMIN: any = [
  pageDashboard,
  pageUserManagement,
  pageMyTimesheet,
  pageTimesheetApproval,
  // pageProjectApproval,
  pageProjectManagement,
  pageLeaveManagement,
];

export const MENU_MANAGER: any = [
  pageDashboard,
  pageMyTimesheet,
  pageTimesheetApproval,
  pageTeamManagement,
  pageLeaveManagement,
];

export const MENU_HR: any = [
  pageDashboard,
  pageUserManagement,
  pageTimesheetApproval,
  // pageProjectApproval,
  // pageProjectManagement,
  pageLeaveManagement,
  pageMasterSetup,
];

export const MENU_EMPLOYEE: any = [
  pageDashboard,
  pageMyTimesheet,
  pageLeaveManagement,
];

export const MENU_MANAGING_DIRECTORN: any = [
  pageDashboard,
  pageUserManagement,
  pageTimesheetApproval,
  // pageProjectApproval,
  // pageProjectManagement,
  pageLeaveManagement,
  pageMasterSetup,
];

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  public menuItems: any[];
  public isCollapsed = true;
  public isShowSlice = true;

  constructor(private router: Router, private elf: ElementRef) {}

  ngOnInit() {
    this.menuItems = ROUTES.filter((menuItem) => menuItem);
    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
    });
    this.hideAndShowNavbar();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInside = this.elf.nativeElement.contains(event.target);

    if (!this.isCollapsed && !clickedInside) {
      this.isCollapsed = true;
    }
  }

  hideAndShowNavbar() {
    if (!this.isShowSlice) {
      this.elf.nativeElement.parentElement
        .querySelector(".main-content")
        .classList.add("leftSlideOn");
      this.elf.nativeElement.querySelector("nav").classList.add("collabSlide");
      this.isShowSlice = !this.isShowSlice;
    } else {
      this.elf.nativeElement.parentElement
        .querySelector(".main-content")
        .classList.remove("leftSlideOn");
      this.elf.nativeElement
        .querySelector("nav")
        .classList.remove("collabSlide");
      this.isShowSlice = !this.isShowSlice;
    }
  }
}
